// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-component {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
}
.loading-component.lg {
  height: 100vh;
}
.loading-component.sm {
  height: 100%;
}
.loading-component svg {
  width: 60px;
  height: 100px;
}
.loading-component .text {
  font-size: 25px;
  color: #6d68aa;
}

@keyframes bastonetes-loading {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(120px);
  }
}
.loading-component g {
  animation: bastonetes-loading 1.5s cubic-bezier(0.3, 0.5, 0.2, 1.4) infinite;
  transform-origin: bottom center;
}

#plt2 {
  animation-delay: 0.2s;
}

#plt3 {
  animation-delay: 0.1s;
}

.shadow-content {
  position: relative;
  width: 60px;
  height: 5px;
}

.shadow-loading {
  width: 10px;
  height: 2px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  transform-origin: 50%;
  z-index: -1;
  left: 4%;
  filter: blur(1px);
  animation: shadow 1.5s cubic-bezier(0.3, 0.5, 0.2, 1.4) infinite;
}
.shadow-loading:nth-child(2) {
  left: 42%;
  animation-delay: 0.1s;
}
.shadow-loading:nth-child(3) {
  left: auto;
  right: 4%;
  animation-delay: 0.2s;
}

@keyframes shadow {
  50% {
    transform: scaleX(1.5);
    opacity: 1;
  }
  0%, 100% {
    transform: scaleX(0.5);
    opacity: 0.4;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Loading/loading.sass"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;AAAJ;AAEI;EACI,aAAA;AAAR;AAEI;EACI,YAAA;AAAR;AAEI;EACI,WAAA;EACA,aAAA;AAAR;AAEI;EACI,eAAA;EACA,cAAA;AAAR;;AAEA;EACI;IAEI,0BAAA;EAAN;EAEE;IACI,4BAAA;EAAN;AACF;AACA;EACI,4EAAA;EACA,+BAAA;AACJ;;AACA;EACI,qBAAA;AAEJ;;AAAA;EACI,qBAAA;AAGJ;;AADA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;AAIJ;;AAFA;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;EACA,gEAAA;AAKJ;AAHI;EACI,SAAA;EACA,qBAAA;AAKR;AAHI;EACI,UAAA;EACA,SAAA;EACA,qBAAA;AAKR;;AAHA;EACI;IACI,sBAAA;IACA,UAAA;EAMN;EAJE;IAEI,sBAAA;IACA,YAAA;EAKN;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@400;800;900&display=swap\")\r\n\r\n.loading-component\r\n    display: flex\r\n    justify-content: center\r\n    align-items: center\r\n    flex-direction: column\r\n    width: 100%\r\n    \r\n    &.lg\r\n        height: 100vh\r\n   \r\n    &.sm\r\n        height: 100%\r\n\r\n    & svg\r\n        width: 60px\r\n        height: 100px\r\n\r\n    & .text\r\n        font-size: 25px\r\n        color: #6d68aa\r\n\r\n@keyframes bastonetes-loading\r\n    0%,\r\n    100%\r\n        transform: translateY(0px)\r\n\r\n    50%\r\n        transform: translateY(120px)\r\n\r\n.loading-component g\r\n    animation: bastonetes-loading 1.5s cubic-bezier(0.3, 0.5, 0.2, 1.4) infinite\r\n    transform-origin: bottom center\r\n\r\n#plt2\r\n    animation-delay: 0.2s\r\n\r\n#plt3\r\n    animation-delay: 0.1s\r\n\r\n.shadow-content\r\n    position: relative\r\n    width: 60px\r\n    height: 5px\r\n\r\n.shadow-loading\r\n    width: 10px\r\n    height: 2px\r\n    border-radius: 50%\r\n    background-color: rgba(0, 0, 0, 0.5)\r\n    position: absolute\r\n    transform-origin: 50%\r\n    z-index: -1\r\n    left: 4%\r\n    filter: blur(1px)\r\n    animation: shadow 1.5s cubic-bezier(0.3, 0.5, 0.2, 1.4) infinite\r\n\r\n    &:nth-child(2)\r\n        left: 42%\r\n        animation-delay: 0.1s\r\n\r\n    &:nth-child(3)\r\n        left: auto\r\n        right: 4%\r\n        animation-delay: 0.2s\r\n\r\n@keyframes shadow\r\n    50%\r\n        transform: scaleX(1.5)\r\n        opacity: 1\r\n\r\n    0%,\r\n    100%\r\n        transform: scaleX(0.5)\r\n        opacity: 0.4\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
